import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import HeadContainer from '../../../common/head-container';

const ErrorPage = ({ setScreenNumber, telegramLink }) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-brand/bg.png')}")`
      }}
    >
      <div className={styles.headContainer}>
        <HeadContainer
          setScreenNumber={setScreenNumber}
          telegramOnly
          customTelegramLink={telegramLink}
        />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>Щось пішло не так:(</p>
        <p className={styles.description}>
          Спробуй відсканувати QR код<br></br> знову!
        </p>
      </div>
      {/*<button onClick={() => setScreenNumber(1)}>Повернутися на головну</button>*/}
    </div>
  );
};

export default ErrorPage;
